<template>
  <div
    class="offcanvas offcanvas-fullscreen-sm-down offcanvas-end"
    tabindex="-1"
    id="offcanvaInfo"
    ref="offcanvaInfo"
    data-bs-backdrop="static"
  >
    <!-- data-bs-backdrop="static" -->
    <div class="bg-top-nav border offcanvas-header py-2">
      {{ $t('Modifier Group Detail')  }}
      <button
        type="button"
        style="font-size: small;"
        class="btn-close shadow-none text-reset"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      />
    </div>

    <div
      class="offcanvas-body"
      v-if="loading"
    >
      <placeholder-content :is-load="true" />
    </div>
    <div
      class="offcanvas-body p-0"
      v-else
    >
      <div class="border-bottom py-2 px-3">
        <div class="d-flex">
          <!-- <img
            :src="data.thumbnail_url"
            class="images_box_info rounded me-2"
          > -->
          <div class="row g-3 py-2">
            <b style="font-size: 18px;" class="mt-2">
              {{ data.name }}
            </b>
            <div
              class="d-flex mt-0 "
              style="font-size: 13px;"
            >
              <label
                class="pe-2"
              >
                {{ $t('Last Update') + ': ' + formatDateTime(data.updated_at) }}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div
        class="card m-3"
      >
        <div class="card-header">
          <i class="fa-solid fa-circle-info me-2" />
          {{ $t('Modifier Group Information') }}
        </div>
        <div class="card-body pb-0">
          <div class="row" style="font-size: 13px;">
            <div class="col-6 col-md-3 mb-3">
              <b>
                {{ $t('Selection Type') + ':' }}
              </b>
            </div>
            <div class="col-6 col-md-9 mb-3">
              {{ $t(data.select_type) }}
            </div>
            <template v-if="$hasFeature('feature_inventory')">
            <div class="col-6 col-md-3 mb-3">
              <b>
                {{ $t('Recipe Behavior') + ':' }}
              </b>
            </div>
            <div class="col-6 col-md-9 mb-3">
              <span
                :class="['badge', data.recipe_behavior === 'Stack'? 'bg-primary': 'bg-dark']"
              >
                <i :class="['fa-solid' , data.recipe_behavior === 'Stack'? 'fa-cubes': 'fa-chart-pie']" />
                {{ $t(data.recipe_behavior) }}
              </span>
            </div>
            </template>
            <div class="col-6 col-md-3 mb-3">
              <b>
                {{ $t('Required Status') + ':' }}
              </b>
            </div>
            <div class="col-6 col-md-9 mb-3">
              <span
                :class="['badge', data.required? 'bg-success': 'bg-secondary']"
              >
                <i :class="['fa-solid' , data.required? 'fa-check': 'fa-xmark']" />
                {{ data.required? $t('Yes'): $t('No') }}
              </span>
            </div>
            <div class="col-6 col-md-3 mb-3">
              <b>
                {{ $t('Create By') + ':' }}
              </b>
            </div>
            <div class="col-6 col-md-9 mb-3">
              {{ data.created_by }}
            </div>
            <template v-if="data.products && data.products.length > 0">
              <div class="col-6 col-md-3 mb-3">
                <b>
                  {{ $t('Products') + ':' }}
                </b>
              </div>
              <div class="col-6 col-md-9 mb-3">
                <span
                  v-for="product in data.products"
                  :key="product"
                  class="badge bg-light text-dark border me-1 mb-1"
                >
                  {{ $t(product) }}
                </span>
              </div>
            </template>
            <template v-if="data.tags && data.tags.length > 0">
              <div class="col-6 col-md-3 mb-3">
                <b>
                  {{ $t('Tags') + ':' }}
                </b>
              </div>
              <div class="col-6 col-md-9 mb-3">
                <span
                  v-for="tag in data.tags"
                  :key="tag.name"
                  class="badge me-1 mb-1"
                  :style="{ color: tag.color, border: `1px solid ${tag.color}`, backgroundColor: 'transparent' }"
                >
                  {{ tag.name }}
                </span>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div
        class="card m-3"
      >
        <div class="border-bottom-0 card-header">
          <i class="fa-solid fa-list-check me-2" />
          {{ $t('Options Overview') }}
        </div>
        <div class="card-body p-0">
          <vue3-easy-data-table
            ref="datatableItemOptions"
            :headers="itemOptionHeaders"
            :items="datatableItemOptions.items"
            :loading="datatableItemOptions.loading"
            :theme-color="'#515151'"
            :hide-footer="true"
            :hide-rows-per-page="true"
            :empty-message="$t('No Available Data')"
            :table-min-height="null"
            :body-item-class-name="bodyItemClassNameFunction"
            table-class-name='customize-table-hide-footer-in-offcanvas'
          >
            <template #header-price="header">
              <span class="w-100 text-end">
                {{ header.text }}
              </span>
            </template>
            <template #item-name="item">
              {{ $ln(item) }}
            </template>
            <template #item-price="item">
              {{ formatDigit(item.price) }}
            </template>
            <template #item-default="item">
              <input
                v-if="data.select_type === 'Multiple Select'"
                class="form-check-input shadow-none me-1"
                type="checkbox"
                :checked="item.default"
                disabled
              >
              <input
                v-else
                class="form-check-input shadow-none me-1"
                type="radio"
                :checked="item.default"
                disabled
              >
              <label
                class=""
              >
                {{ item.default? $t('Yes'): $t('No') }}
              </label>
            </template>
            <template #item-recipes="item">
              <span
                v-if="!item.recipes || item.recipes.length === 0"
                class="badge"
                style="background: #f8f9fa; color: #6c757d; border: 1px solid #dee2e6; font-size: 11px; font-weight: 500;"
              >
                <i class="fa-solid fa-ban me-1" style="font-size: 9px; opacity: 0.7;" />
                {{ $t('No recipe') }}
              </span>
              <template v-else>{{ showItemRecipes(item.recipes) }}</template>
            </template>
            <template #loading>
              <i class="fa-solid fa-spinner fa-spin fa-2xl" />
            </template>
          </vue3-easy-data-table>
        </div>
      </div>
    </div>
    <div
      class="bg-light border-top justify-content-center modal-footer py-2"
      v-if="!loading"
    >
      <div
        class="btn-group dropdown"
      >
        <button
          type="button"
          class="btn btn-sm btn-primary dropdown-toggle"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          @mouseenter="isHovered = true"
          @mouseleave="isHovered = false"
        >
          <i class="fa-solid fa-ellipsis me-1" :class="isHovered? 'fa-fade': ''" />
          {{ $t('More Action') }}
        </button>
        <ul class="dropdown-menu">
          <li>
            <a
              class="dropdown-item"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              @click="() => {
                $parent.offcanvasFroms.open = true;
                $parent.offcanvasFroms.id = id;
                $parent.offcanvasFroms.type = 'EDIT';
              }"
            >
              <i class="fa-solid fa-square-pen" />
              {{ $t('Edit') }}
            </a>
          </li>
          <li>
            <a
              class="dropdown-item"
              @click="handleDelete(id)"
            >
              <i class="fa-solid fa-trash-can" />
              {{ $t('Delete') }}
            </a>
          </li>
        </ul>
      </div>
      <button
        type="button"
        data-bs-dismiss="offcanvas"
        class="border-dark-subtle btn-sm btn btn-light me-2 ms-2"
      >
        {{ $t('Cancel') }}
      </button>
    </div>
  </div>
</template>

<script lang="js">
import Vue3EasyDataTable from 'vue3-easy-data-table';
import Select2 from 'vue3-select2-component';
import { Modifiers } from '@/services/endpoint/modifiers.service';
import PlaceholderContent from '@/plugins/PlaceholderContent.vue';
import Ladda from '@/plugins/Ladda.vue';
import moment from "moment";
import numeral from 'numeral';
import { distance } from '@/store/date-fns'
import Popper from "vue3-popper";
import FieldItemOptions from './assets/template/datatable/FieldItemOptions';

export default {
  props: {
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      datatableItemOptions: {
        loading: false,
        headers: FieldItemOptions,
        items: []
      },
      isHovered: false,
      loading: true,
      data: {}
    }
  },
  components: {
    Vue3EasyDataTable,
    Select2,
    PlaceholderContent,
    Ladda,
    Popper
  },
  methods: {
    showItemRecipes(items) {
      return items.map(item => {
        return item.name + ' (' + this.formatNumber(item.quantity) + item.unit_symbol + ')';
      }).join(', ');
    },
    bodyItemClassNameFunction(column, rowNumber) {
      let className = 'border-0';
      const columnStart = ['name'];
      const columnCenter = [];
      const columnEnd = ['price'];
      if (columnStart.includes(column)) {
        className += ' text-start';
      }
      if (columnCenter.includes(column)) {
        className += ' text-center';
      }
      if (columnEnd.includes(column)) {
        className += ' text-end';
      }
      return className;
    },
    formatNumber(value) {
      return numeral(value).format("0,0");
    },
    formatDigit(value) {
      if ((value < 0.01) && value != 0) {
        return numeral(value).format("0,0.0000");
      }
      return numeral(value).format("0,0.00");
    },
    formatNumberDigit(value) {
      return numeral(value).format("0,0.0000");
    },
    formatNumberTwoDigit(value) {
      return numeral(value).format("0,0.00");
    },
    async getInfoData() {
      this.loading = true;
      await Modifiers.getInfo(this.id).then(res => {
        this.data = res.data.data;
        this.datatableItemOptions.items = res.data.data.options;
        this.loading = false;
      }).catch(err => {
			  throw err;
      });
    },
    formatDate(value) {
      return moment(value).format('DD/MM/YYYY');
    },
    formatDateTime(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss');
    },
    dateDistance(value) {
      return distance(value);
    },
    async handleDelete(id) {
      try {
        let self = this;
        let title = this.$t("Delete this Modifier group") + '?';
        let html = this.$t("You won't be able to revert this! This group will be unlinked from all active products.");
        let confirmButtonText =
          '<i class="fas fa-check-circle me-1"></i>' + this.$t("Confirm");
        this.$swal({
          icon: "warning",
          iconColor: "#FF7043",
          title: title,
          // text: "You will not be able to undo this action.",
          html: html,
          showCancelButton: true,
          cancelButtonText: this.$t("Cancel"),
          confirmButtonText: confirmButtonText,
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-primary me-2",
            cancelButton: "btn btn-danger",
          },
          focusConfirm: false,
          showLoaderOnConfirm: true,
          preConfirm: async function () {
            return Modifiers.delete(id)
              .then((response) => {
                self.$parent.fetchData();
                self.$toast.success("<B>" + self.$t('Success') + "</B>\n" + self.$t('Delete Success!'));
                $(self.$refs.offcanvaInfo).offcanvas('hide');
              })
              .catch((error) => {
                if (error?.response?.status === 403) {
                  self.$swal.update({
                    title: self.$t('Access Denied'),
                    confirmButtonText: '<i class="fas fa-redo me-1"></i>' + self.$t("Try again"),
                    text: self.$t('You do not have permission to access this page.')
                  });
                  self.$swal.showValidationMessage(
                    self.$t(error?.response?.data?.message)
                  )
                } else if (error?.response?.data?.code === "VALIDATION") {
                  self.$swal.showValidationMessage(
                    self.$t(error?.response?.data?.message)
                  )
                } else {
                  self.$toast.warn(error?.response?.data?.message);
                }
              })
          },
        });
      } catch (error) {
      }
    },
  },
  async mounted() {
    $(this.$refs.offcanvaInfo).offcanvas('show');

    $(this.$refs.offcanvaInfo).on('shown.bs.offcanvas',async () => {
      try {
        await this.getInfoData();
      } catch (err) {
      }
    });

    $(this.$refs.offcanvaInfo).on('hidden.bs.offcanvas', () => {
      this.$parent.formInfo.open = false;
    });
  },
  computed: {
    // คอลัมน์สูตรของ option ซ่อนเมื่อแพ็กไม่มี feature_inventory
    itemOptionHeaders() {
      const headers = this.datatableItemOptions.headers(this.$t);
      return this.$hasFeature('feature_inventory') ? headers : headers.filter(h => h.value !== 'recipes');
    },

  },
  watch: {
  }
}
</script>
